/**
 *  @fileOverview Navigation handler
 *
 *  @author       Peter Schmiz <peter.schmiz@possible.com>
 *
 */

import forEach from 'lodash/forEach';
import detectIt from 'detect-it';

const OPEN_DROPDOWN_CLASS = 'show-submenu';

class Navigation {
  init() {
    this.isMobileMenuActive = false;
    this.initDOMElements();
    this.initBindings();
    if (detectIt.deviceType !== 'mouseOnly') {
      this.setMobilmenuFocus('hidden');
    }
  }

  initDOMElements() {
    this.header = document.body.querySelector('header');
    this.mobileToggle = document.body.querySelector('[data-header-mobile-toggle]');
    this.advisorLink = document.body.querySelector('[data-header-advisor]');
    this.dropdownMenuContainer = document.body.querySelector('[data-dropdownmenu-container]');
    if (this.dropdownMenuContainer !== null) {
      this.desktopMenuButtons = this.dropdownMenuContainer.querySelectorAll('li.always-visible > a');
      this.dropdownMenu = this.dropdownMenuContainer.querySelector('li ul');
      if (this.dropdownMenu !== null) {
        this.dropdownMenu.setAttribute('data-dropdownmenu', '');
        this.dropdownMenuExpander = this.dropdownMenu.previousElementSibling;
        if (this.dropdownMenuExpander !== null && this.dropdownMenuExpander !== undefined) {
          this.dropdownUrl = this.dropdownMenuExpander.getAttribute('href');
          if (this.dropdownMenu !== null) {
            this.setDropdownAria(false);
          }
        }
      }
      this.allMenuButtons = this.dropdownMenuContainer.querySelectorAll('li a');
    }
  }

  initBindings() {
    document.body.querySelector('main').addEventListener('focus', () => {
      if (this.isMobileMenuActive === true) {
        this.mobileToggle.focus();
      }
    }, false);

    document.body.addEventListener('click', (e) => {
      if (this.dropDownActive === true && e.target !== this.dropdownMenuExpander) {
        this.hideDropdown();
      }
    }, false);

    if (
      this.dropdownMenuExpander !== null &&
      this.dropdownMenuExpander !== undefined &&
      detectIt.deviceType !== 'mouseOnly'
    ) {
      this.bindTabletDropdown = this.tabletDropdown.bind(this);
      this.dropdownMenuExpander.addEventListener('click', this.bindTabletDropdown, false);
    }

    if (this.mobileToggle !== null) {
      this.mobileToggle.addEventListener('click', (e) => {
        e.preventDefault();
        if (this.header.classList.contains('header--mobile-menu-active')) {
          this.toggleMobileMenu('close');
        } else {
          this.toggleMobileMenu('open');
        }
      }, false);
    }

    window.addEventListener('resize', () => {
      if (this.header.classList.contains('header--mobile-menu-active')) {
        this.toggleMobileMenu('close');
      }

      this.hideDropdown();
    });

    if (this.advisorLink !== null) {
      this.advisorLink.addEventListener('click', (e) => {
        if (detectIt.deviceType !== 'mouseOnly') {
          e.preventDefault();
        }

        if (this.header.classList.contains('header--advisor-menu-active')) {
          this.header.classList.remove('header--advisor-menu-active');
        } else {
          this.header.classList.add('header--advisor-menu-active');
        }
      }, false);
    }

    if (this.header !== null) {
      const logo = this.header.querySelector('.header__logo a');
      if (logo !== null) {
        logo.addEventListener('focus', () => {
          this.hideDropdown();
        }, false);
      }
    }

    if (this.dropdownMenuContainer !== null && this.desktopMenuButtons !== null && detectIt.deviceType === 'mouseOnly') {
      forEach(this.desktopMenuButtons, (element) => {
        element.addEventListener('focus', () => {
          this.hideDropdown();
          if (element.nextElementSibling !== null) {
            this.showDropdown();
          }
        }, false);
      });
      this.dropdownMenuContainer.querySelector('li:first-of-type').addEventListener('mouseover', () => {
        this.showDropdown();
      });
      this.dropdownMenuContainer.querySelector('li:first-of-type').addEventListener('mouseout', () => {
        this.hideDropdown();
      });
    }
  }

  showDropdown() {
    this.dropDownActive = true;
    this.setDropdownAria(true);
    if (this.dropdownMenu) {
      this.dropdownMenu.classList.add(OPEN_DROPDOWN_CLASS);
    }
  }

  hideDropdown() {
    this.dropDownActive = false;
    this.setDropdownAria(false);
    if (this.dropdownMenu) {
      this.dropdownMenu.classList.remove(OPEN_DROPDOWN_CLASS);
    }
  }

  setDropdownAria(value) {
    if (detectIt.deviceType === 'mouseOnly' && this.dropdownMenuExpander) {
      this.dropdownMenuExpander.setAttribute('aria-expanded', value);
    }
  }

  setMobilmenuFocus(state) {
    let stateObj = {};

    if (state === 'hidden') {
      stateObj = {
        aria: 'true',
        tabindex: -1,
      };
    } else {
      stateObj = {
        aria: '',
        tabindex: 0,
      };
    }

    forEach(this.allMenuButtons, (element) => {
      element.setAttribute('aria-hidden', stateObj.aria);
      element.setAttribute('tabindex', stateObj.tabindex);
    });
  }

  toggleMobileMenu(state) {
    if (state === 'close') {
      this.isMobileMenuActive = false;
      this.header.classList.remove('header--mobile-menu-active');
      document.body.classList.remove('fullscreen-active');
      this.mobileToggle.setAttribute('aria-label', 'Open menu');
      this.setMobilmenuFocus('hidden');
    } else {
      this.isMobileMenuActive = true;
      this.header.classList.add('header--mobile-menu-active');
      document.body.classList.add('fullscreen-active');
      this.mobileToggle.setAttribute('aria-label', 'Close menu');
      this.setMobilmenuFocus('visible');
    }
  }

  tabletDropdown(e) {
    if (
      detectIt.deviceType !== 'mouseOnly' &&
      window.innerWidth > 768 &&
      this.dropdownMenu.classList.contains(OPEN_DROPDOWN_CLASS) === false
    ) {
      e.preventDefault();
      this.showDropdown();
      return false;
    }
    return true;
  }
}

export const navigation = new Navigation();



// WEBPACK FOOTER //
// ./src/js/modules/navigation.js